import React, { useEffect } from 'react';
import HeartRate from "../Graphs/HeartRate";
import BodyTemperature from "../Graphs/BodyTemperature";
import SpO2 from "../Graphs/SpO2";
import BMI from "../Graphs/BMI";
import BloodGlucose from "../Graphs/BloodGlucose";
import BloodPressure from "../Graphs/BloodPressure";
import VitalStats from "../Graphs/VitalStats";
import Generic from "../Graphs/Generic";
import NewBMI from '../Graphs/NewBMI';
import { LoaderLoader } from '../../../utils/CommonLibrary';
import { VITAL_KEYWORDS } from '../../../../constants';



function VitalsDisplayPanel({ vitalsDataProp, vitalStatsInfo, ranges, isLoading, vitals, vitalStatsRanges}) {
    // Use props directly, with fallback default values
    const vitalsData = vitalsDataProp || {
        bmi: { current: "" },
        heartRate: {current: "", history: [] },
        bodyTemperature: {current: "", history: [] },
        spO2: {current: "", history: [] },
        bloodGlucose: {current: "", type: "", history: [] },
        bloodGlucoseRandom: {current: "", type: "", history: [] },
        bloodPressure: {current: "", systolic: "", diastolic: "", history: [] }
    };

   
    return (
        <div className='row'>
            {/* loader */}
            {isLoading && <LoaderLoader isLoading={isLoading} />}

            <div className='col-md-12 mb-3'>
                {/* <VitalStats data={vitalsData} /> */}
            </div>
            

            <div className='col-md-12 mb-3'>
                <div className='row'>
                    { 
                        Object.keys(vitalStatsInfo).map((vitalKey) => (
                            <div className='col-md-6 mb-3'>
                                { 
                                    vitalKey === "bp"? 
                                    <BloodPressure data={vitalStatsInfo[vitalKey]} />                                    
                                    :
                                    (vitalStatsInfo[vitalKey]?.history && vitalStatsInfo[vitalKey]?.history?.length > 0) &&
                                    <Generic data={vitalStatsInfo[vitalKey]} ranges={vitalStatsRanges[vitalKey]} />
                                }
                            </div>
                        ))
                    }
                    {/* {vitalsData.bmi?.history?.length > 0 && (
                        <div className='col-md-6 mb-3'>
                            <NewBMI bmiValue={vitalsData.bmi.current} data={vitalsData.bmi} ranges={ranges?.bmi || []}
                            />
                        </div>
                    )}
                    {vitalsData.heartRate.history.length > 0 && (
                        <div className='col-md-6 mb-3'>
                            <HeartRate data={vitalsData.heartRate} ranges={ranges?.heartRate || []}/>
                        </div>
                    )}
                    {vitalsData.bodyTemperature.history.length > 0 && (
                        <div className='col-md-6 mb-3'>
                            <BodyTemperature data={vitalsData.bodyTemperature} ranges={ranges?.bodyTemperature || []} vitalInfo={vitals[VITAL_KEYWORDS.BODY_TEMPERATURE]} fetchSingleVitalGraph={fetchSingleVitalGraph}/>
                        </div>
                    )}
                    {vitalsData.spO2.history.length > 0 && (
                        <div className='col-md-6 mb-3'>
                            <SpO2 data={vitalsData.spO2} ranges={ranges?.spO2 || []} vitalInfo={vitals["spo2"]} 
                                fetchSingleVitalGraph={fetchSingleVitalGraph}
                            />
                        </div>
                    )}
                    {vitalsData.bloodGlucose.history.length > 0 && (
                        <div className='col-md-6 mb-3'>
                            <BloodGlucose bloodGlucose={vitalsData.bloodGlucose} bloodGlucoseRandom={vitalsData.bloodGlucoseRandom}
                                bloodGlucoseRanges={ranges?.bloodGlucose || []}
                                bloodGlucoseRandomRanges={ranges?.bloodGlucoseRandom || []}
                                vitalInfo={{'fasting': VITAL_KEYWORDS.FASTING_BLOOD_GLUCOSE, random: VITAL_KEYWORDS.RANDM_BLOOD_GLUCOSE}}
                                fetchSingleVitalGraph={fetchSingleVitalGraph}
                            />
                        </div>
                    )}    
                    {vitalsData.bloodPressure.history.length > 0 && (
                        <div className='col-md-6 mb-3'>
                            <BloodPressure data={vitalsData.bloodPressure} />
                        </div>
                    )} */}
                </div>
            </div>
        </div>
    );
}

export default VitalsDisplayPanel; 